import type { FunctionComponent } from "react";

import { NotificationItem } from "scmp-app/components/news-ticker/notification-item";

import { Email, Message } from "./styles";

export type Props = {
  email: string;
  onClose?: () => void;
};

export const AccountActivation: FunctionComponent<Props> = ({ email, onClose }) => (
  <NotificationItem onClose={onClose}>
    <Message>
      We sent an activation email to you at <Email>{email}</Email>. Please check your email box.
    </Message>
  </NotificationItem>
);

AccountActivation.displayName = "AccountActivation";
